/**
 * @owner @Appboy/clip
 */
export const messageArchivingConsumption =
  "/analytics_dashboard/:app_group_id/message_archiving_credit_consumption_detail_data";
